// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

erpnext.show_quality_inspection_dialog = function (qi_names, frm) {
	let idx = 0;

	const next = async () => {
		if (idx >= qi_names.length) {
			frm.reload_doc();
			return;
		}

		const qi_name = qi_names[idx];
		const { message: qi_doc } = await frappe.call({
			method: "frappe.client.get",
			args: { doctype: "Quality Inspection", name: qi_name },
		});

		if (!qi_doc) {
			idx++;
			next();
			return;
		}

		// Seed per-row accepted flag from the existing status (default: Accepted)
		const readings_data = (qi_doc.readings || []).map((r) => ({
			...r,
			status_accepted: r.status !== "Rejected" ? 1 : 0,
		}));
		const has_readings = readings_data.length > 0;
		const total = qi_names.length;
		const is_last = idx === total - 1;
		let action_taken = false;
		// Track overall status via a local variable instead of relying on a hidden field
		let selected_status = qi_doc.status === "Rejected" ? "Rejected" : "Accepted";

		const fields = [
			{
				fieldtype: "HTML",
				fieldname: "item_info",
				// @dokos: Espresso section header instead of inline styles
				options: `<div class="dk-sh">
					<span class="dk-sh__title">${frappe.utils.escape_html(qi_doc.item_code)}</span>
					${qi_doc.item_name ? `<span class="dk-sh__meta">${frappe.utils.escape_html(qi_doc.item_name)}</span>` : ""}
				</div>`,
			},
		];

		if (has_readings) {
			fields.push({
				fieldtype: "Table",
				fieldname: "readings",
				label: __("Readings"),
				cannot_add_rows: true,
				in_place_edit: true,
				data: readings_data,
				get_data: () => readings_data,
				fields: [
					{
						fieldtype: "Data",
						fieldname: "specification",
						label: __("Parameter"),
						in_list_view: 1,
						read_only: 1,
						columns: 3,
					},
					{
						fieldtype: "Data",
						fieldname: "value",
						label: __("Criteria"),
						in_list_view: 1,
						read_only: 1,
						columns: 3,
					},
					{
						fieldtype: "Data",
						fieldname: "reading_1",
						label: __("Reading"),
						in_list_view: 1,
						columns: 4,
					},
					{
						fieldtype: "Check",
						fieldname: "status_accepted",
						label: __("Accepted"),
						in_list_view: 1,
						columns: 2,
					},
				],
			});
		}

		// Overall status pill toggle — value is kept in `selected_status`, not a form field
		fields.push(
			{
				fieldtype: "HTML",
				fieldname: "status_toggle",
				// @dokos: dk-field label + a segmented control (mounted after show), no inline styles
				options: `<div class="dk-field">
					<label>${__("Overall Status")}</label>
					<div class="qi-status-btns"></div>
				</div>`,
			},
			{ fieldtype: "Small Text", fieldname: "remarks", label: __("Remarks") }
		);

		const qi_dialog = new frappe.ui.Dialog({
			title: __("Quality Inspection {0} / {1}", [idx + 1, total]),
			size: has_readings ? "extra-large" : "small",
			fields,
			primary_action_label: is_last ? __("Submit") : __("Submit & Next"),
			primary_action: async (values) => {
				qi_dialog.disable_primary_action();
				// Convert per-row Check flag back to the string status the server expects
				const readings_for_server = (values.readings || []).map((r) => ({
					reading_1: r.reading_1,
					status: r.status_accepted ? "Accepted" : "Rejected",
				}));
				try {
					await frappe.call({
						method: "erpnext.controllers.stock_controller.submit_quality_inspection",
						args: {
							qi_name,
							readings: readings_for_server,
							status: selected_status,
							remarks: values.remarks || "",
						},
						freeze: true,
					});
					frappe.show_alert({ message: __("{0} submitted", [qi_name]), indicator: "green" });
					action_taken = true;
					qi_dialog.hide();
					idx++;
					next();
				} catch {
					qi_dialog.enable_primary_action();
				}
			},
			secondary_action_label: __("Skip"),
			secondary_action: () => {
				action_taken = true;
				qi_dialog.hide();
				idx++;
				next();
			},
			onhide: () => {
				if (!action_taken) {
					idx++;
					next();
				}
			},
		});

		qi_dialog.show();

		// @dokos: Accepted / Rejected as Espresso tab buttons — the choice is kept in `selected_status`
		qi_dialog.$wrapper.find(".qi-status-btns").append(
			erpnext.dokos.ui.tab_buttons({
				label: __("Overall Status"),
				value: selected_status,
				options: [
					{
						label: __("Accepted"),
						value: "Accepted",
						icon_left: "check",
						css_class: "qi-status-btn",
					},
					{ label: __("Rejected"), value: "Rejected", icon_left: "x", css_class: "qi-status-btn" },
				],
				on_change: (value) => (selected_status = value),
			})
		);
	};

	next();
};
